/**
 * Contacts stat band — 6 KPI cards from GET /contacts/statistic.
 * Mirrors the contract-stat-band pattern: flat Card + StatGroup.
 */
import { Card, CardBody, Skeleton } from '@vnetwork/ui/primitives';
import { Stat, StatGroup } from '@vnetwork/ui/data';
import { useContactStatistic, type ContactStatistic } from '@/api/contacts';

interface StatDef {
  key: keyof ContactStatistic;
  label: string;
  dotColor: string;
}

const STAT_DEFS: StatDef[] = [
  { key: 'total',              label: 'Total',       dotColor: 'var(--vn-primary-solid)' },
  { key: 'unclassified',       label: 'Unclassified', dotColor: 'var(--vn-fg-muted)' },
  { key: 'warm_lead',          label: 'Warm Lead',   dotColor: 'var(--vn-warning-solid)' },
  { key: 'sale_qualified_lead',label: 'SQL',          dotColor: 'var(--vn-success-solid)' },
  { key: 'cool_lead',          label: 'Cool Lead',   dotColor: 'var(--vn-info-solid)' },
  { key: 'un_qualified_lead',  label: 'Unqualified', dotColor: 'var(--vn-danger-solid)' },
];

export function ContactStatBand() {
  const { data, isLoading } = useContactStatistic();
  const stats = data?.result;

  return (
    <Card flat style={{ marginBottom: 'var(--vn-space-4)' }}>
      <CardBody>
        {isLoading ? (
          <StatGroup columns={6}>
            {STAT_DEFS.map((d) => (
              <Skeleton key={d.key} style={{ height: 56 }} />
            ))}
          </StatGroup>
        ) : (
          <StatGroup columns={6}>
            {STAT_DEFS.map((d) => {
              const count = stats?.[d.key];
              return (
                <Stat
                  key={d.key}
                  label={d.label}
                  dotColor={d.dotColor}
                  value={typeof count === 'number' ? count.toLocaleString('en-US') : '0'}
                />
              );
            })}
          </StatGroup>
        )}
      </CardBody>
    </Card>
  );
}
